import Sentry from "./services/sentry";
import React from "react";
import { createRoot } from "react-dom/client";
import { App } from "antd";
import ErrorFallback from "./ErrorFallback";

import "bootstrap/dist/css/bootstrap.css";
import MyApp from "./App";

// react router
import { BrowserRouter } from "react-router-dom";

// auth context
import { AuthContextProvider } from "./context/AuthContext";
import { ConfigProvider } from "antd";

const rootElement = document.getElementById("root");
const root = createRoot(rootElement, {
  onRecoverableError: Sentry.reactErrorHandler(),
});

root.render(
  <AuthContextProvider>
    <BrowserRouter>
      <ConfigProvider
        theme={{ token: { fontFamily: '"Tajawal", sans-serif' } }}
      >
        <App>
          <Sentry.ErrorBoundary fallback={ErrorFallback}>
            <MyApp />
          </Sentry.ErrorBoundary>
        </App>
      </ConfigProvider>
    </BrowserRouter>
  </AuthContextProvider>
);
